import Cookies from 'js-cookie'
export function getCookies (Name) {
  return Cookies.get(Name)
}
export function setCookies (Name, value) {
  return Cookies.set(Name, value, { expires: 1 })
}

export function removeCookies (Name) {
  return Cookies.remove(Name)
}

export function setCookiesWithExpire (Name, value, day) {
  return Cookies.set(Name, value, { expires: day })
}



// WEBPACK FOOTER //
// ./src/utils/cookies.js